import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames/bind';
import styles from './SearchBar.css';

const cx = classNames.bind(styles);

const getContainerClassName = ({ iconOnLeft, additionalStyle, className }) => {
  return cx({
    'right-inner-addon': !iconOnLeft,
    'left-inner-addon': iconOnLeft,
    [additionalStyle]: !!additionalStyle,
    [className]: !!className,
  });
};

class SearchBar extends React.Component {
  render() {
    const {
      input,
      placeholder,
      className,
      id,
      additionalStyle,
      iconOnLeft,
    } = this.props;
    const containerClassName = getContainerClassName({
      iconOnLeft,
      additionalStyle,
      className,
    });

    return (
      <div className={containerClassName} onClick={this.props.onClick}>
        <i className="fa fa-search search-items" />
        <input
          {...input}
          className={`form-control ${styles.rounded}`}
          placeholder={placeholder}
          type="text"
          id={id}
        />
      </div>
    );
  }
}

SearchBar.propTypes = {
  placeholder: PropTypes.string,
  iconOnLeft: PropTypes.bool,
};

export default SearchBar;
